import React, { useEffect,  useState } from 'react'
import { Box, Grid, Typography } from '@mui/material'
// import LoginForm from '../../components/account/login-form'
import LoginFederatedForm from '../../components/account/login-federated-form'
import { useUserContext, useMuniContext } from 'strview-common'
// import { useMuniContext } from '../../external/muni-context'


const Login = () => {
    const [muni, setMuni] = useState({ "exists": false })
    // const muniIdRef = useRef(null)
    const { getFedAuthUrl } = useUserContext()
    const { validateMuni } = useMuniContext()
    const urlParams = new URLSearchParams(window.location.search)
    const federatedLogout = urlParams.get('federatedLogout')
    console.log("federatedLogout", federatedLogout)

    useEffect(() => {
        // we will check to see if the muniId is valid
        const muniId = window.location.pathname.split('/')[1]
        const response = validateMuni(muniId)
        response.then((data) => {
            console.log("data", data)
            setMuni(data)
        }).catch((error) => {
            console.log("error", error)
        })
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    if (federatedLogout === "true") {
        // redirect to the logout endpoint

        const { url: logoutEndpoint } = getFedAuthUrl('logout')
        // const logoutEndpoint = `https://${process.env.REACT_APP_AWS_HOSTED_UI_DOMAIN}.auth.${process.env.REACT_APP_AWS_REGION}.amazoncognito.com/logout?client_id=${process.env.REACT_APP_CLIENT_ID}&logout_uri=http%3A%2F%2Flocalhost%3A3000%2Flogin`
        console.log("logoutEndpoint", logoutEndpoint)
        window.location.href = logoutEndpoint
        return null
    }

    // if this is /login without a muniId/login then redirect to muniId/login
    const firstPart = window.location.pathname.split('/')[1]
    if (firstPart === "login") {
        const muniLoc = localStorage.getItem('muni')
        const muniId = muniLoc ? JSON.parse(muniLoc).muniId : null
        window.location.href = `/${muniId}/login`
        return null
    }




    if (muni.exists === false) {
        return (
            <>
                <div>Municipality {muni.id} does not exist</div>
            </>
        )
    }

    return (
        <>
            <Grid container direction="column" spacing={2}>
                <Grid item>
                    <Box
                        sx={{
                            marginTop: 8,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        <Typography variant="h4" component="h1" gutterBottom>
                            {muni.name}
                        </Typography>
                    </Box>
                </Grid>

                <Grid item>
                    <LoginFederatedForm />
                </Grid>
                {/* <Grid item>
                    <LoginForm />
                </Grid> */}
            </Grid>
        </>
    )
}

export default Login
